import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import LoadingSpinner from './components/LoadingSpinner';
// Lazy load all pages for optimal code splitting
const Home = lazy(() => import('./pages/Home'));
const FindUs = lazy(() => import('./pages/FindUs'));
const Products = lazy(() => import('./pages/Products'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const CustomPressing = lazy(() => import('./pages/CustomPressing'));
const CiderMillNews = lazy(() => import('./pages/CiderMillNews'));
const FAQs = lazy(() => import('./pages/FAQs'));
const Recipes = lazy(() => import('./pages/Recipes'));
const Contact = lazy(() => import('./pages/Contact'));

// Preload critical routes on user interaction
const preloadRoute = (importFn: () => Promise<any>) => {
  const componentImport = importFn();
  return componentImport;
};

// Preload most important routes after initial load
if (typeof window !== 'undefined') {
  setTimeout(() => {
    preloadRoute(() => import('./pages/FindUs'));
    preloadRoute(() => import('./pages/Products'));
  }, 2000);
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App min-h-screen flex flex-col">
        <Header />
        
        <main className="flex-grow pb-20">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/find-us" element={<FindUs />} />
              <Route path="/products" element={<Products />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/custom-pressing" element={<CustomPressing />} />
              <Route path="/cider-mill-news" element={<CiderMillNews />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/recipes" element={<Recipes />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Suspense>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
